import { render, staticRenderFns } from "./PageService.vue?vue&type=template&id=895c4218&scoped=true"
import script from "./PageService.vue?vue&type=script&lang=js"
export * from "./PageService.vue?vue&type=script&lang=js"
import style0 from "./PageService.vue?vue&type=style&index=0&id=895c4218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895c4218",
  null
  
)

export default component.exports